import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { UserContext } from "components/ProjectSpecificComponents/Contexts/UserContext"
import { TOnClick } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import { observer } from "mobx-react"
import React, { useContext } from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import SettingsButton from "../atoms/Buttons/SettingsButton"
import ReConnectButton from "../atoms/Buttons/ReConnectButton"
import Logo from "../../Global/atoms/Logo"
import GoAdminButton from "../atoms/Buttons/GoAdminButton"
import ConfigButton from "../atoms/Buttons/ConfigButton"

interface Props {
	hidden?: boolean
	onTapBackground?: TOnClick
	onNavigation?: () => void
}

const MobileNavBarMenu = observer(
	({ hidden = false, onTapBackground = () => {}, onNavigation = () => {} }: Props) => {
		const store = useStore()
		const { t } = useTranslation()
		const { setUser } = useContext(UserContext)
		const location = useLocation()
		const logOut = () => {
			setUser(undefined)
			store.removeConnection()
		}

		return (
			<AnimatedBase
				style={{
					left: hidden ? "-100vw" : 0,
				}}
			>
				<BgTapArea onClick={onTapBackground} />

				<MenuContainer>
					<Logo />

					<HyperDiv
						direction="column"
						alignedLeft
						spaceBetweenElems="1rem"
						padding="30px 0px 0px 0px"
					>
						{/* Admin stuff for user side */}
						{!store.isInAdminSection && store.userHasAdminAccess && (
							<>
								<GoAdminButton />
							</>
						)}
						{/* Admin stuff for admin side */}
						{store.isInAdminSection && (
							<>
								<ConfigButton />
								<SettingsButton />
								<ReConnectButton />
							</>
						)}
					</HyperDiv>
				</MenuContainer>
			</AnimatedBase>
		)
	}
)

export default MobileNavBarMenu

const AnimatedBase = styled.div`
	position: fixed;
	top: 0;
	width: 100vw;
	height: 100vh;

	// Animation
	transition: 0.4s var(--default-slide-transition-fn);
	transition-property: left;

	z-index: 20;
`

const BgTapArea = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -1;
`

const MenuContainer = styled.div`
	position: absolute;
	overflow-y: auto;
	top: 0;
	left: 0;
	width: 230px;
	height: 100vh;
	padding: 10px;
	background-color: var(--white);
	box-shadow: 4px 0 4px rgba(0, 0, 0, 0.25);
`
